import { isIE, supportsResizeAndIntersectionObserver } from "@1js/acui-common";

import { isV9ButtonEnabled } from "./sharedExperimentsNext";
import { staticRibbonExperiments } from "./staticRibbonExperiments";

// Internal record for if responsive scaling is turned off
const responsiveScalingExpValues: Record<
  "SingleLine" | "Multiline",
  boolean | undefined
> = {
  SingleLine: undefined,
  Multiline: undefined,
};

export const isResponsiveRibbonScalingSLRFeatureEnabled = (
  isExperimentalFeatureEnabled?: (feature: string) => boolean
) => {
  return isResponsiveRibbonScalingFeatureEnabled(
    "SingleLine",
    isExperimentalFeatureEnabled
  );
};

export const isResponsiveRibbonScalingMLRFeatureEnabled = (
  isExperimentalFeatureEnabled?: (feature: string) => boolean
) => {
  return isResponsiveRibbonScalingFeatureEnabled(
    "Multiline",
    isExperimentalFeatureEnabled
  );
};

export const responsiveScalingExperiments = {
  StatusBarDOMMemoizationEnabled:
    "Microsoft.Office.SharedOnline.StatusBarDOMMemoizationEnabled",
  StatusBarCssBasedResponsiveScalingEnabled:
    "Microsoft.Office.SharedOnline.StatusBarCssBasedResponsiveScalingEnabled",
  ExcelStatusBarCssBasedResponsiveScalingEnabled:
    "Microsoft.Office.Excel.StatusBarCssBasedResponsiveScalingEnabled",
};

/**
 * Should responsive scaling for the given ribbon mode be used
 * @param ribbonMode The ribbon mode to check
 * @param isExperimentalFeatureEnabled Function to check if the feature is enable
 * @param forceResponsiveScalingOff Optional, force responsive scaling off (should be rarely used)
 * @returns If responsive scaling should be used, taking into account if scaling is forced off
 */
export const isResponsiveRibbonScalingFeatureEnabled = (
  ribbonMode: "SingleLine" | "Multiline",
  isExperimentalFeatureEnabled?: (feature: string) => boolean,
  forceResponsiveScalingOff?: boolean
) => {
  // If we were given a forceResponsiveScalingOff value, use it
  if (forceResponsiveScalingOff !== undefined) {
    responsiveScalingExpValues[ribbonMode] = !forceResponsiveScalingOff;
  }

  if (
    isExperimentalFeatureEnabled?.(
      staticRibbonExperiments.ribbonScalingSafeguard
    )
  ) {
    responsiveScalingExpValues[ribbonMode] =
      responsiveScalingExpValues[ribbonMode] !== false &&
      isExperimentalFeatureEnabled !== undefined &&
      isV9ButtonEnabled(isExperimentalFeatureEnabled) &&
      !isIE() &&
      supportsResizeAndIntersectionObserver();
  } else {
    responsiveScalingExpValues[ribbonMode] =
      !!responsiveScalingExpValues[ribbonMode] ||
      (isExperimentalFeatureEnabled !== undefined &&
        isV9ButtonEnabled(isExperimentalFeatureEnabled) &&
        !isIE() &&
        supportsResizeAndIntersectionObserver());
  }

  return responsiveScalingExpValues[ribbonMode];
};

let responsiveScalingTopBarValue: boolean | undefined = undefined;
export const isTopBarResponsiveScalingFeatureEnabled = (
  isExperimentalFeatureEnabled?: (feature: string) => boolean,
  forceResponsiveScalingOff?: boolean
) => {
  // If we were given a forceResponsiveScalingOff value, use it
  if (forceResponsiveScalingOff !== undefined) {
    responsiveScalingTopBarValue = !forceResponsiveScalingOff;
  }

  responsiveScalingTopBarValue =
    responsiveScalingTopBarValue !== false &&
    isExperimentalFeatureEnabled !== undefined &&
    (isExperimentalFeatureEnabled(
      staticRibbonExperiments.deterministicRibbonScaling
    ) ||
      isExperimentalFeatureEnabled(
        staticRibbonExperiments.deterministicRibbonScalingSetting
      )) &&
    isV9ButtonEnabled(isExperimentalFeatureEnabled) &&
    supportsResizeAndIntersectionObserver();

  return responsiveScalingTopBarValue;
};
